"use client";

import React from 'react';
export const offset = 4;
function dropIndicatorRender(props) {
  const {
    dropPosition,
    dropLevelOffset,
    prefixCls,
    indent,
    direction = 'ltr'
  } = props;
  const startPosition = direction === 'ltr' ? 'left' : 'right';
  const endPosition = direction === 'ltr' ? 'right' : 'left';
  const style = {
    [startPosition]: -dropLevelOffset * indent + offset,
    [endPosition]: 0
  };
  switch (dropPosition) {
    case -1:
      style.top = -3;
      break;
    case 1:
      style.bottom = -3;
      break;
    default:
      // dropPosition === 0
      style.bottom = -3;
      style[startPosition] = indent + offset;
      break;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${prefixCls}-drop-indicator`
  });
}
export default dropIndicatorRender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tree/utils/dropIndicator.js
// module id = 3666
// module chunks = 0